import { useMutation, useQueryClient } from "react-query";

import StudentProgressService from "../../services/StudentProgress";

import { QUERY_KEY } from "./useListStudentProgress";

function useCreateStudentProgress() {
  const queryClient = useQueryClient();

  return useMutation(StudentProgressService.createStudentProgressions, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY);
    },
  });
}

export default useCreateStudentProgress;
